import { ETACost } from '~/api/ETA';

export const normalizeDeliveryCost = (deliveryMethodCost: ETACost): ETACost => {
  if (!deliveryMethodCost.shipping || deliveryMethodCost.shipping < 0) {
    deliveryMethodCost.shipping = 0;
    deliveryMethodCost.shippingPounds = '0';
  }

  if (!deliveryMethodCost.threshold || deliveryMethodCost.threshold < 0) {
    deliveryMethodCost.threshold = 0;
    deliveryMethodCost.thresholdPounds = '0';
  }

  if (
    !deliveryMethodCost.serviceFee ||
    (deliveryMethodCost.serviceFee || -1) < 0
  ) {
    deliveryMethodCost.serviceFee = 0;
    deliveryMethodCost.serviceFeeShippingPounds = '0';
  }

  if (
    !deliveryMethodCost.serviceFeeThreshold ||
    (deliveryMethodCost.serviceFeeThreshold || -1) < 0
  ) {
    deliveryMethodCost.serviceFeeThreshold = 0;
    deliveryMethodCost.serviceFeeThresholdPounds = '0';
  }

  return { ...deliveryMethodCost };
};
